/**
 * Маппер из ответа Supabase в доменный тип Notification
 */

import type { Notification, NotificationType } from '../model';

// Supabase возвращает join-ы как объект или массив — нормализуем
function unwrapRelation<T>(value: T | T[] | null): T | null {
  if (Array.isArray(value)) return value[0] ?? null;
  return value;
}

/** Преобразует строку из БД (с join-ами) в объект Notification */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Supabase не генерирует точный тип для вложенных join-ов
export function mapRowToNotification(item: Record<string, any>): Notification {
  const actor = unwrapRelation(item.actor);
  const wishlist = unwrapRelation(item.wishlist);
  const wish = unwrapRelation(item.wish);

  return {
    id: item.id,
    userId: item.user_id,
    // Supabase возвращает string, но колонка содержит только валидные NotificationType
    type: item.type as NotificationType,
    wishlistId: item.wishlist_id || undefined,
    wishId: item.wish_id || undefined,
    gameId: item.secret_santa_game_id || undefined,
    actorId: item.actor_id,
    isRead: item.is_read,
    createdAt: new Date(item.created_at),
    actor: actor ? {
      id: actor.id,
      displayName: actor.display_name,
      lastName: actor.last_name || undefined,
      username: actor.username,
      avatarUrl: actor.avatar_url || undefined,
    } : undefined,
    wishlist: wishlist ? {
      id: wishlist.id,
      title: wishlist.title,
    } : undefined,
    wish: wish ? {
      id: wish.id,
      title: wish.title,
      imageUrl: (wish.image_urls && wish.image_urls.length > 0) ? wish.image_urls[0] : undefined,
    } : undefined,
    // secretSantaGame не загружается в этом запросе
    secretSantaGame: undefined,
  };
}